import { Inject, Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as ObjectActions from './device-parameters.actions';
import * as AppActions from '../app/actions';
import { HttpClient } from '@angular/common/http';
import { GeneralApiResponseInterface } from '../../layout/main/main.model';
import { DeviceParametersInterface } from './device-parameters.model';
import { IotDeviceManagementPortalAppState } from '../iotDeviceManagementPortalApp.reducer';
import { Store } from '@ngrx/store';

@Injectable()
export class DeviceParametersEffects {
  constructor(
    private actions$: Actions<ObjectActions.DeviceParametersActions>,
    private http: HttpClient,
    private readonly store: Store<IotDeviceManagementPortalAppState>,
    @Inject('API_BASE_URL') private readonly baseUrl: string,
  ) {}

  private DEVICES_URLS = {
    GET: {
      DEVICE_PARAMETERS: '/device-parameters',
    },
  };

  @Effect()
  getDeviceParameters$ = this.actions$.pipe(
    ofType(ObjectActions.DeviceActionTypes.GetDeviceParameters),
    switchMap((objectData: ObjectActions.GetDeviceParameters) => {
      this.store.dispatch(new AppActions.ShowLoader());
      const url = `${this.baseUrl}${this.DEVICES_URLS.GET.DEVICE_PARAMETERS}`;

      return this.http.get<GeneralApiResponseInterface<DeviceParametersInterface[]>>(url).pipe(
        switchMap((response: GeneralApiResponseInterface<DeviceParametersInterface[]>) => {
          return of(new ObjectActions.GetDeviceParametersCompleted(response), new AppActions.HideLoader());
        }),
        catchError((errorRes) => {
          return of(new ObjectActions.FetchError(errorRes), new AppActions.HideLoader());
        }),
      );
    }),
  );
}
